import { render, staticRenderFns } from "./RegistrationPersonalSuccess.vue?vue&type=template&id=c766d8be&scoped=true&"
import script from "./RegistrationPersonalSuccess.vue?vue&type=script&lang=js&"
export * from "./RegistrationPersonalSuccess.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationPersonalSuccess.vue?vue&type=style&index=0&id=c766d8be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c766d8be",
  null
  
)

export default component.exports